import {
  Box,
  ButtonIcon,
  Chip,
  Icon,
  Typography,
} from "@saviynt/design-system";
import { useIntl } from "react-intl";

import { useSelectedRows } from "../../context/SelectedRowsContext";

export default function SelectedOwners() {
  const { selectedRows = [], removeSelectedRow } = useSelectedRows();
  const intl = useIntl();

  return (
    <Box
      className="NHI-selected-owners-chips-container"
      dataTestId="NHI-selected-owners-chips"
    >
      <Typography
        kind="body2-bold"
        desktop="body2-bold-d"
        mobile="body2-bold-d"
        color="--color-foreground-neutral-bold"
      >
        {intl.formatMessage(
          {
            id: "urbwja",
            description: "Label showing the number of selected owners",
            defaultMessage:
              "{count, plural, =0 {Selected Owners (0)} one {Selected Owners (1)} other {Selected Owners (#)}}",
          },
          { count: selectedRows.length },
        )}
      </Typography>
      {selectedRows.length > 0 && (
        <Box className="NHI-selected-owners-chips-list">
          {selectedRows.map((owner) => {
            const ownerId = owner.userkey || owner.id;
            return (
              <Chip
                key={ownerId}
                kind="outlined"
                label={owner.username}
                size="small"
                rightIcon={
                  <ButtonIcon
                    size="large"
                    kind="ghost"
                    icon={<Icon kind="CloseCircle" size="xSmall" />}
                    ariaLabel={intl.formatMessage({
                      defaultMessage: "Remove Owner",
                      description:
                        "Aria label for button to remove selected owner from the list",
                      id: "oFFiC4",
                    })}
                    onClick={() => removeSelectedRow(ownerId)}
                  />
                }
              />
            );
          })}
        </Box>
      )}
    </Box>
  );
}
